import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Col, Input, Modal, Row, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import { ObjectiveSymbol } from 'app/config/constants';
import { setFilterPendingApprove } from 'app/entities/filters/filters.reducer';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import * as _ from 'lodash';
import ApproveObjectiveKRComponent from './approve-objective';
import { getItemPendingApprove, submitApprove } from './category-approve.reducer';
import { columnsApprove } from './config';

type IApproveObjectiveKRProps = {
    isOpen: boolean;
    onClose: (isReload?: boolean) => void;
    itemsSelected: any[],
    selectedPeriod: number
};

const { Search } = Input;

export const PendingApproval = ({ isOpen, onClose, itemsSelected, selectedPeriod }: IApproveObjectiveKRProps) => {
    const dispatch = useAppDispatch();
    const loading = useAppSelector(state => state.categoryApprove.loading);
    const updating = useAppSelector(state => state.categoryApprove.updating);
    const account = useAppSelector(state => state.authentication.account);
    const filters = useAppSelector(state => state.filters.pendingApprove);

    const [isOpenModalConfirmApprove, setOpenModalConfirmApprove] = useState(false);
    const [isOpenModalApproveItemSelected, setOpenModalApproveItemSelected] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [processDocumentId, setProcessDocumentId] = useState(null);
    const [recordPendingApprove, setRecordPendingApprove] = useState([]);

    useEffect(() => {
        handleGetRecordPendingApprove();
    }, [])

    useEffect(() => {
        if (recordPendingApprove.length > 0) {
            const allRowKeys = getAllRowKeys(recordPendingApprove);
            setExpandedRowKeys(allRowKeys);
        }
    }, [recordPendingApprove])

    const getAllRowKeys = (item) => {
        return item.reduce((keys, value, idx) => {
            keys.push(`${value?.itemId}`);

            if (value.children) {
                keys = keys.concat(getAllRowKeys(value.children));
            }

            return keys;
        }, []);
    };


    const handleGetRecordPendingApprove = () => {
        const payload = {
            itemIds: itemsSelected,
            searchText: filters?.searchText
        }
        dispatch(getItemPendingApprove(payload)).then((res) => {
            if (res && res.payload) {
                const result = (res.payload as any)?.data
                setRecordPendingApprove(result)
            }
        });
    }

    const handleFreeTextSearchQuery = query => {
        dispatch(setFilterPendingApprove({ ...filters, searchText: query }))
    };

    const handleClose = () => {
        onClose();
    };

    const handleOpenModalConfirmApprove = () => {
        setOpenModalConfirmApprove(true);
    }

    const handleConfirmApprove = () => {
        setOpenModalConfirmApprove(false);
        const payloadApprove = {
            senderId: account?.id,
            ownerId: filters?.accountableId,
            planPeriodId: filters?.planPeriodId,
            itemIds: itemsSelected,
            year: filters.year
        }
        dispatch(submitApprove(payloadApprove)).then((res) => {
            if (res && res.payload) {
                const result = (res.payload as any)?.data
                if (result) {
                    setProcessDocumentId(result);
                    setOpenModalApproveItemSelected(true);
                    handleClose()
                }
            }
        });
    }

    const handleCloseModalApproveItemSelected = () => {
        setOpenModalApproveItemSelected(false);
        handleClose();
    }

    console.log('111222', selectedPeriod);

    return (
        <Modal open={isOpen} maskClosable={false} confirmLoading={updating} footer={null} onCancel={handleClose} width={'80vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>Phê duyệt mục tiêu - {filters?.accountableName}</Title>
            </div>
            <div className="table">
                <div className="header">
                    <Col md={8}>
                        <Row className='w-100'>
                            <Col md={18}>
                                <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={13}>
                        <Row className='w-100 justify-content-end gap-2'>
                            <Button size="large" onClick={handleOpenModalConfirmApprove} disabled={updating} className="green">
                                Trình phê duyệt
                            </Button>
                        </Row>
                    </Col>
                </div>
                <Table tableLayout='fixed' scroll={{ y: '60vh' }}
                    expandable={{
                        expandedRowKeys,
                        onExpandedRowsChange(newExpandedRowKeys: any) {
                            setExpandedRowKeys(newExpandedRowKeys);
                        },
                    }}
                    rowClassName={(record, index) =>
                        _.startsWith(record.itemCode, ObjectiveSymbol) ? "fw-bold" : "" // Định nghĩa lớp CSS cho dòng lẻ
                    }
                    loading={loading || updating} bordered dataSource={recordPendingApprove.map(x => ({
                        ...x,
                        key: x.itemId,
                        children: x.children?.map(y => ({ ...y, key: y.itemId }))
                    }))} pagination={false} columns={columnsApprove} />
            </div>
            {isOpenModalApproveItemSelected && <ApproveObjectiveKRComponent selectedPeriod={selectedPeriod} planPeriodId={filters?.planPeriodId} accountTableId={filters?.accountableId} accountableName={filters?.accountableName} documentId={processDocumentId} isOpen={isOpenModalApproveItemSelected} onClose={handleCloseModalApproveItemSelected} />}

            <ModalConfirmComponent
                visible={isOpenModalConfirmApprove}
                onCancel={() => {
                    setOpenModalConfirmApprove(false);
                }}
                onConfirm={handleConfirmApprove}
                isLoading={updating}
                title={`Bạn có chắc chắn muốn trình phê duyệt?`}
            />
        </Modal>
    );
};

export default PendingApproval;
